import type { MoneyMessage } from '../../../../types/MoneyMessage';
import type { ProductUnit } from '../../../../types/ProductUnit';
import { Text } from '../../../cdl/Text/Text';
import { formatNumber } from '../../../common/helpers/formatNumber.helper';
import { formatPrice } from '../../../common/helpers/formatPrice.helper';
import { Characters } from '../../../common/helpers/unicode.helper';
import { useEnums } from '../../../common/hooks/useEnums';
import type { ItemModel } from '../../../common/models/ItemModel';

interface PriceVolumeSublineProps {
    price: MoneyMessage;
    volume: number;
    unit: ItemModel['unit'] | ProductUnit;
}

export const PriceVolumeSubline = ({ price, volume, unit }: PriceVolumeSublineProps) => {
    const { getHumanReadableValue } = useEnums();
    const unitLabel = getHumanReadableValue('productUnit', unit);

    return (
        <Text variant="extraSmall" color="foreground.muted" style={{ whiteSpace: 'nowrap' }}>
            {formatPrice(price)}
            {Characters.NO_BREAK_SPACE}
            {Characters.SOLIDUS}
            {Characters.NO_BREAK_SPACE}
            {unitLabel}
            {Characters.EN_SPACE}
            {Characters.MIDDLE_DOT}
            {Characters.EN_SPACE}
            {formatNumber({
                number: volume,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })}
            {Characters.NO_BREAK_SPACE}
            {unitLabel}
        </Text>
    );
};
